// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { savedOrderListFilterStyles } from "@eisinc/Overrides/Widgets/SavedOrderList/SavedOrderListFilter";
import { xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

savedOrderListFilterStyles.container = {
    gap: 15,
    css: css`
        margin-bottom: 30px;
    `,
};
savedOrderListFilterStyles.datesGridItem = { width: [12, 12, 12, 12, 6] };
savedOrderListFilterStyles.datesContainer = { gap: 15 };
savedOrderListFilterStyles.fromGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        > div {
            width: 100%;
            line-height: 0;
        }
    `,
};
savedOrderListFilterStyles.toGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        > div {
            width: 100%;
        }
    `,
};
savedOrderListFilterStyles.buttonsItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        padding-top: 10px;
    `,
};
savedOrderListFilterStyles.clearFiltersButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lt", "sm")} {
            width: 100%;
        }
    `,
};
savedOrderListFilterStyles.toDate = {
    cssOverrides: {
        formField: css`
            ${xScreen("lt", "sm")} {
                > div {
                    margin-top: 0 !important;
                }
            }
            ${xScreen("gte", "sm")} {
                margin-top: 18px;
            }
        `,
    },
};
savedOrderListFilterStyles.orderTotalGridItem = {
    width: [12, 12, 12, 12, 6],
};
savedOrderListFilterStyles.orderTotalContainer = { gap: 15 };
savedOrderListFilterStyles.orderTotalOperatorGridItem = { width: [12, 12, 6, 6, 6] };
savedOrderListFilterStyles.orderTotalAmountGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        align-items: flex-end;
    `,
};
savedOrderListFilterStyles.orderTotalAmountTextField = {};
